// import React, { useState, useEffect } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Paper,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   Typography,
// } from "@mui/material";

// const DisplayDictionary = () => {
//   const API_URL = process.env.REACT_APP_API_URL;
//   const [recipes, setRecipes] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

//   const [selectedRecipe, setSelectedRecipe] = useState(null);
//   const [formData, setFormData] = useState({});

//   useEffect(() => {
//     fetchRecipes();
//   }, []);

//   const fetchRecipes = async () => {
//     try {
//       const response = await fetch(`${API_URL}/dictionary/entries`); // Replace with your backend endpoint
//       const data = await response.json();
//       console.log(data);
//       setRecipes(data);
//     } catch (error) {
//       console.error("Error fetching recipes:", error);
//     }
//   };

//   const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleRowsPerPageChange = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleOpenDetailsDialog = (recipe) => {
//     setSelectedRecipe(recipe);
//     setOpenDetailsDialog(true);
//   };

//   const handleOpenEditDialog = (recipe) => {
//     setSelectedRecipe(recipe);
//     setFormData({ ...recipe });
//     setOpenEditDialog(true);
//   };

//   const handleOpenDeleteDialog = (recipe) => {
//     setSelectedRecipe(recipe);
//     setOpenDeleteDialog(true);
//   };

//   const handleCloseDialogs = () => {
//     setOpenDetailsDialog(false);
//     setOpenEditDialog(false);
//     setOpenDeleteDialog(false);
//     setSelectedRecipe(null);
//     setFormData({});
//   };

//   const handleEditSubmit = async () => {
//     try {
//       const response = await fetch(
//         `${API_URL}/cuisine/updatecuisine/${selectedRecipe.cuisine_id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         },
//       );

//       if (!response.ok) {
//         throw new Error("Failed to update recipe");
//       }

//       const updatedRecipe = await response.json();
//       setRecipes((prev) =>
//         prev.map((recipe) =>
//           recipe.cuisine_id === updatedRecipe.cuisine_id
//             ? updatedRecipe
//             : recipe,
//         ),
//       );
//       console.log("Recipe updated:", updatedRecipe);
//     } catch (error) {
//       console.error("Error updating recipe:", error);
//     } finally {
//       handleCloseDialogs();
//     }
//   };

//   const handleDeleteSubmit = async () => {
//     try {
//       const response = await fetch(
//         `${API_URL}/cuisine/deletecuisine/${selectedRecipe.cuisine_id}`,
//         {
//           method: "DELETE",
//         },
//       );

//       if (!response.ok) {
//         throw new Error("Failed to delete recipe");
//       }

//       setRecipes((prev) =>
//         prev.filter(
//           (recipe) => recipe.cuisine_id !== selectedRecipe.cuisine_id,
//         ),
//       );
//       console.log("Recipe deleted:", selectedRecipe);
//     } catch (error) {
//       console.error("Error deleting recipe:", error);
//     } finally {
//       handleCloseDialogs();
//     }
//   };

//   const handleInputChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   return (
//     <>
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>ID</TableCell>
//               <TableCell>Cuisine Type</TableCell>
//               <TableCell>Image url</TableCell>
//               <TableCell>Actions</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {recipes
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map((recipe) => (
//                 <TableRow key={recipe.cuisine_id}>
//                   <TableCell>{recipe.cuisine_id}</TableCell>
//                   <TableCell>{recipe.cuisine_type}</TableCell>
//                   <TableCell>{recipe.url}</TableCell>
//                   <TableCell
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       //   justifyContent: "space-evenly",
//                       gap: 2,
//                     }}
//                   >
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       size="small"
//                       onClick={() => handleOpenEditDialog(recipe)}
//                       sx={{ marginRight: 1 }}
//                     >
//                       Edit
//                     </Button>
//                     <Button
//                       variant="contained"
//                       color="error"
//                       size="small"
//                       onClick={() => handleOpenDeleteDialog(recipe)}
//                       sx={{ marginRight: 1 }}
//                     >
//                       Delete
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       color="info"
//                       size="small"
//                       onClick={() => handleOpenDetailsDialog(recipe)}
//                     >
//                       See Details
//                     </Button>
//                   </TableCell>
//                 </TableRow>
//               ))}
//           </TableBody>
//         </Table>
//         <TablePagination
//           rowsPerPageOptions={[5, 10, 25]}
//           component="div"
//           count={recipes.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handlePageChange}
//           onRowsPerPageChange={handleRowsPerPageChange}
//         />
//       </TableContainer>

//       {/* See Details Dialog */}
//       <Dialog open={openDetailsDialog} onClose={handleCloseDialogs}>
//         <DialogTitle>Recipe Details</DialogTitle>
//         <DialogContent>
//           <Typography variant="body1">
//             <b>ID:</b> {selectedRecipe?.cuisine_id}
//           </Typography>
//           <Typography variant="body1">
//             <b>User:</b> {selectedRecipe?.user_id}
//           </Typography>
//           <Typography variant="body1">
//             <b>Cuisine Type:</b> {selectedRecipe?.cuisine_type}
//           </Typography>
//           <Typography variant="body1">
//             <b>Image url:</b> {selectedRecipe?.url}
//           </Typography>
//           <Typography variant="body1">
//             <b>Created Date:</b> {selectedRecipe?.created_at}
//           </Typography>
//           <Typography variant="body1">
//             <b>Updated Date:</b> {selectedRecipe?.updated_at}
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialogs} color="primary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Dialog */}
//       <Dialog open={openEditDialog} onClose={handleCloseDialogs}>
//         <DialogTitle>Edit Recipe</DialogTitle>
//         <DialogContent>
//           <TextField
//             label="User"
//             name="user_id"
//             value={formData.user_id || ""}
//             onChange={handleInputChange}
//             fullWidth
//             margin="dense"
//           />
//           <TextField
//             label="Cuisine Type"
//             name="cuisine_type"
//             value={formData.cuisine_type || ""}
//             onChange={handleInputChange}
//             fullWidth
//             margin="dense"
//           />
//           <TextField
//             label="Image url"
//             name="url"
//             value={formData.url || ""}
//             onChange={handleInputChange}
//             fullWidth
//             margin="dense"
//           />
//           <TextField
//             label="Created Date"
//             name="created_at"
//             value={formData.created_at || ""}
//             onChange={handleInputChange}
//             fullWidth
//             margin="dense"
//           />

//           <TextField
//             label="Updated Date"
//             name="updated_at"
//             value={formData.updated_at || ""}
//             onChange={handleInputChange}
//             fullWidth
//             margin="dense"
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialogs} color="secondary">
//             Cancel
//           </Button>
//           <Button onClick={handleEditSubmit} color="primary">
//             Save
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Dialog */}
//       <Dialog open={openDeleteDialog} onClose={handleCloseDialogs}>
//         <DialogTitle>Confirm Deletion</DialogTitle>
//         <DialogContent>
//           Are you sure you want to delete the recipe{" "}
//           <b>{selectedRecipe?.cuisine_type}</b>?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialogs} color="secondary">
//             Cancel
//           </Button>
//           <Button onClick={handleDeleteSubmit} color="error">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default DisplayDictionary;





// import React, { useState, useEffect } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Paper,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   Typography,
// } from "@mui/material";

// const DisplayDictionary = () => {
//   const API_URL = process.env.REACT_APP_API_URL;

//   const [entries, setEntries] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const [openDetails, setOpenDetails] = useState(false);
//   const [openEdit, setOpenEdit] = useState(false);
//   const [openDelete, setOpenDelete] = useState(false);

//   const [selectedEntry, setSelectedEntry] = useState(null);
//   const [formData, setFormData] = useState({});

//   // ================= FETCH =================
//   useEffect(() => {
//     fetchEntries();
//   }, []);

//   const fetchEntries = async () => {
//     try {
//       const res = await fetch(`${API_URL}/dictionary/entries`);
//       const result = await res.json();
//       setEntries(result.data || []);
//     } catch (err) {
//       console.error("Fetch error:", err);
//     }
//   };

//   // ================= PAGINATION =================
//   const handlePageChange = (_, newPage) => setPage(newPage);

//   const handleRowsPerPageChange = (e) => {
//     setRowsPerPage(parseInt(e.target.value, 10));
//     setPage(0);
//   };

//   // ================= DIALOGS =================
//   const handleOpenDetails = (entry) => {
//     setSelectedEntry(entry);
//     setOpenDetails(true);
//   };

//   const handleOpenEdit = (entry) => {
//     setSelectedEntry(entry);
//     setFormData(entry);
//     setOpenEdit(true);
//   };

//   const handleOpenDelete = (entry) => {
//     setSelectedEntry(entry);
//     setOpenDelete(true);
//   };

//   const handleClose = () => {
//     setOpenDetails(false);
//     setOpenEdit(false);
//     setOpenDelete(false);
//     setSelectedEntry(null);
//     setFormData({});
//   };

//   // ================= INPUT =================
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // ================= UPDATE =================
//   const handleUpdate = async () => {
//     try {
//       const res = await fetch(`${API_URL}/dictionary/entries`, {
//         method: "POST", // backend uses UPSERT
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       const result = await res.json();

//       if (res.ok) {
//         fetchEntries();
//       } else {
//         console.error(result.message);
//       }
//     } catch (err) {
//       console.error("Update error:", err);
//     } finally {
//       handleClose();
//     }
//   };

//   // ================= DELETE =================
//   const handleDelete = async () => {
//     try {
//       await fetch(`${API_URL}/dictionary/entries/${selectedEntry.id}`, {
//         method: "DELETE",
//       });

//       setEntries((prev) =>
//         prev.filter((e) => e.id !== selectedEntry.id)
//       );
//     } catch (err) {
//       console.error("Delete error:", err);
//     } finally {
//       handleClose();
//     }
//   };

//   return (
//     <>
//       {/* ================= TABLE ================= */}
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Term</TableCell>
//               <TableCell>Term Am</TableCell>
//               <TableCell>Category</TableCell>
//               <TableCell>Language</TableCell>
//               <TableCell>AI</TableCell>
//               <TableCell>Actions</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {entries
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map((entry) => (
//                 <TableRow key={entry.id}>
//                   <TableCell>{entry.term}</TableCell>
//                   <TableCell>{entry.termAm}</TableCell>
//                   <TableCell>{entry.category}</TableCell>
//                   <TableCell>{entry.language}</TableCell>
//                   <TableCell>
//                     {entry.isAIGenerated ? "Yes" : "No"}
//                   </TableCell>

//                   <TableCell sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//                     <Button size="small" variant="contained" onClick={() => handleOpenEdit(entry)}>Edit</Button>
//                     <Button size="small" color="error" variant="contained" onClick={() => handleOpenDelete(entry)}>Delete</Button>
//                     <Button size="small" variant="outlined" onClick={() => handleOpenDetails(entry)}>View</Button>
//                   </TableCell>
//                 </TableRow>
//               ))}
//           </TableBody>
//         </Table>

//         <TablePagination
//           component="div"
//           count={entries.length}
//           page={page}
//           rowsPerPage={rowsPerPage}
//           onPageChange={handlePageChange}
//           onRowsPerPageChange={handleRowsPerPageChange}
//         />
//       </TableContainer>

//       {/* ================= DETAILS ================= */}
//       <Dialog open={openDetails} onClose={handleClose}>
//         <DialogTitle>Entry Details</DialogTitle>
//         <DialogContent>
//           <Typography><b>Term:</b> {selectedEntry?.term}</Typography>
//           <Typography><b>Term Am:</b> {selectedEntry?.termAm}</Typography>
//           <Typography><b>Definition:</b> {selectedEntry?.definition}</Typography>
//           <Typography><b>Definition Am:</b> {selectedEntry?.definitionAm}</Typography>
//           <Typography><b>Category:</b> {selectedEntry?.category}</Typography>
//           <Typography><b>References:</b> {JSON.stringify(selectedEntry?.references_list)}</Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleClose}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* ================= EDIT ================= */}
//       <Dialog open={openEdit} onClose={handleClose}>
//         <DialogTitle>Edit Entry</DialogTitle>
//         <DialogContent>

//           <TextField label="Term" name="term" value={formData.term || ""} onChange={handleChange} fullWidth margin="dense" />
//           <TextField label="Term Am" name="termAm" value={formData.termAm || ""} onChange={handleChange} fullWidth margin="dense" />

//           <TextField label="Definition" name="definition" value={formData.definition || ""} onChange={handleChange} fullWidth multiline rows={3} margin="dense" />
//           <TextField label="Definition Am" name="definitionAm" value={formData.definitionAm || ""} onChange={handleChange} fullWidth multiline rows={3} margin="dense" />

//           <TextField label="Category" name="category" value={formData.category || ""} onChange={handleChange} fullWidth margin="dense" />

//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handleClose}>Cancel</Button>
//           <Button onClick={handleUpdate}>Save</Button>
//         </DialogActions>
//       </Dialog>

//       {/* ================= DELETE ================= */}
//       <Dialog open={openDelete} onClose={handleClose}>
//         <DialogTitle>Delete Entry</DialogTitle>
//         <DialogContent>
//           Delete <b>{selectedEntry?.term}</b>?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleClose}>Cancel</Button>
//           <Button color="error" onClick={handleDelete}>Delete</Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default DisplayDictionary;
import React, { useState, useEffect } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TablePagination, Paper, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, Typography, Box
} from "@mui/material";

const DisplayDictionary = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [entries, setEntries] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openDetails, setOpenDetails] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [selectedEntry, setSelectedEntry] = useState(null);
  const [formData, setFormData] = useState({});

  // ✅ NEW: search state
  const [search, setSearch] = useState("");

  // ================= FETCH =================
  useEffect(() => {
    fetchEntries();
  }, []);

  const fetchEntries = async () => {
    try {
      const res = await fetch(`${API_URL}/dictionary/entries`);
      const result = await res.json();
      setEntries(result.data || []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  // ✅ NEW: SEARCH FUNCTION
  const handleSearch = async () => {
    if (!search.trim()) {
      fetchEntries(); // reset
      return;
    }

    try {
      const res = await fetch(
        `${API_URL}/dictionary/search/multiple?q=${encodeURIComponent(search)}`
      );
      const result = await res.json();

      if (result.success) {
        setEntries(result.data || []);
        setPage(0);
      }
    } catch (err) {
      console.error("Search error:", err);
    }
  };

  // ================= PAGINATION =================
  const handlePageChange = (_, newPage) => setPage(newPage);

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  // ================= DIALOGS =================
  const handleOpenDetails = (entry) => {
    setSelectedEntry(entry);
    setOpenDetails(true);
  };

  const handleOpenEdit = (entry) => {
    setSelectedEntry(entry);
    setFormData(entry);
    setOpenEdit(true);
  };

  const handleOpenDelete = (entry) => {
    setSelectedEntry(entry);
    setOpenDelete(true);
  };

  const handleClose = () => {
    setOpenDetails(false);
    setOpenEdit(false);
    setOpenDelete(false);
    setSelectedEntry(null);
    setFormData({});
  };

  // ================= INPUT =================
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ================= UPDATE =================
  const handleUpdate = async () => {
    try {
      const res = await fetch(`${API_URL}/dictionary/entries`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        fetchEntries();
      }
    } catch (err) {
      console.error("Update error:", err);
    } finally {
      handleClose();
    }
  };

  // ================= DELETE =================
  const handleDelete = async () => {
    try {
      await fetch(`${API_URL}/dictionary/entries/${selectedEntry.id}`, {
        method: "DELETE",
      });

      setEntries((prev) =>
        prev.filter((e) => e.id !== selectedEntry.id)
      );
    } catch (err) {
      console.error("Delete error:", err);
    } finally {
      handleClose();
    }
  };

  return (
    <>
      {/* ================= SEARCH BAR ================= */}
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <TextField
          label="Search term..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          fullWidth
        />
        <Button variant="contained" onClick={handleSearch}>
          Search
        </Button>
        <Button variant="outlined" onClick={fetchEntries}>
          Reset
        </Button>
      </Box>

      {/* ================= TABLE ================= */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Term</TableCell>
              <TableCell>Term Am</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Language</TableCell>
              <TableCell>AI</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {entries
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell>{entry.term}</TableCell>
                  <TableCell>{entry.termAm}</TableCell>
                  <TableCell>{entry.category}</TableCell>
                  <TableCell>{entry.language}</TableCell>
                  <TableCell>
                    {entry.isAIGenerated ? "Yes" : "No"}
                  </TableCell>

                  <TableCell sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Button size="small" variant="contained" onClick={() => handleOpenEdit(entry)}>Edit</Button>
                    <Button size="small" color="error" variant="contained" onClick={() => handleOpenDelete(entry)}>Delete</Button>
                    <Button size="small" variant="outlined" onClick={() => handleOpenDetails(entry)}>View</Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={entries.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </TableContainer>

      {/* ================= DETAILS ================= */}
      <Dialog open={openDetails} onClose={handleClose}>
        <DialogTitle>Entry Details</DialogTitle>
        <DialogContent>
          <Typography><b>Term:</b> {selectedEntry?.term}</Typography>
          <Typography><b>Term Am:</b> {selectedEntry?.termAm}</Typography>
          <Typography><b>Definition:</b> {selectedEntry?.definition}</Typography>
          <Typography><b>Definition Am:</b> {selectedEntry?.definitionAm}</Typography>
          <Typography><b>Category:</b> {selectedEntry?.category}</Typography>
          <Typography><b>References:</b> {JSON.stringify(selectedEntry?.references_list)}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* ================= EDIT ================= */}
      <Dialog open={openEdit} onClose={handleClose}>
        <DialogTitle>Edit Entry</DialogTitle>
        <DialogContent>
          <TextField label="Term" name="term" value={formData.term || ""} onChange={handleChange} fullWidth margin="dense" />
          <TextField label="Term Am" name="termAm" value={formData.termAm || ""} onChange={handleChange} fullWidth margin="dense" />
          <TextField label="Definition" name="definition" value={formData.definition || ""} onChange={handleChange} fullWidth multiline rows={3} margin="dense" />
          <TextField label="Definition Am" name="definitionAm" value={formData.definitionAm || ""} onChange={handleChange} fullWidth multiline rows={3} margin="dense" />
          <TextField label="Category" name="category" value={formData.category || ""} onChange={handleChange} fullWidth margin="dense" />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleUpdate}>Save</Button>
        </DialogActions>
      </Dialog>

      {/* ================= DELETE ================= */}
      <Dialog open={openDelete} onClose={handleClose}>
        <DialogTitle>Delete Entry</DialogTitle>
        <DialogContent>
          Delete <b>{selectedEntry?.term}</b>?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button color="error" onClick={handleDelete}>Delete</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DisplayDictionary;